<template>
  <div class="my_report">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>检测报告</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <div class="search">
        <div class="search_son">
          <span class="input">综合查询</span>
          <el-input
            size="mini"
            placeholder="请输入关键字"
            clearable
            v-model="form.name"
          ></el-input>
        </div>
        <div class="search_son btn">
          <el-button type="primary" round size="mini" @click="search"
            >查询</el-button
          >
        </div>
        <div class="search_son refresh" @click="refresh">
          <i class="el-icon-refresh"></i>刷新-共{{ total }}条数据
        </div>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        highlight-current-row
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="50" label="序号" align="center">
        </el-table-column>
        <el-table-column label="申请编号" align="center">
          <template slot-scope="scope">{{ scope.row.apply_number }}</template>
        </el-table-column>
        <el-table-column label="项目编号" align="center">
          <template slot-scope="scope">{{ scope.row.project_number }}</template>
        </el-table-column>
        <el-table-column label="委托单位" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_client_name
          }}</template>
        </el-table-column>
        <el-table-column label="产品名称" align="center">
          <template slot-scope="scope">{{ scope.row.product_name }}</template>
        </el-table-column>
        <!-- <el-table-column label="原始记录" align="center">
          <template slot-scope="scope">{{
            scope.row.enterprise_client_name
          }}</template>
        </el-table-column> -->
        <el-table-column label="检测报告" align="center">
          <template slot-scope="scope">
            <div
              class="look"
              v-for="(item, i) in scope.row.url"
              :key="i"
              @click="preview(item)"
            >
              {{ item.url_name }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="实时物联" width="160" align="center">
          <template slot-scope="scope">
            <span class="look" @click="toVisual(scope.row)">可视化</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="page_footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="npage"
          :page-size="pagesize"
          layout="total, prev, pager, next,jumper"
          background
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "../../filters/filters.js";
import { httpMyList } from "../../utils/report";
export default {
  data() {
    return {
      npage: 1, //当前页
      pagesize: 10, //每页显示条数
      total: 0, //总条数
      form: {
        name: "",
      },
      tableData: [{}],
    };
  },
  methods: {
    //查询
    search() {
      this._httpMyList(1, this.pagesize, this.form.name);
    },
    //刷新
    refresh() {
      this.form.name = "";
      this._httpMyList(1, this.pagesize, this.form.name);
    },
    //分页
    handleSizeChange(val) {
      this.pagesize = val;
      this._httpMyList(this.npage, this.pagesize, this.form.name);
    },
    handleCurrentChange(val) {
      this.npage = val;
      this._httpMyList(this.npage, this.pagesize, this.form.name);
    },
    //预览word，pdf
    preview(item) {
      if (item.url_oc == "pdf") {
        window.open(item.url_addr, "_blank");
      } else {
        window.open(
          "http://view.officeapps.live.com/op/view.aspx?src=" + item.url_addr,
          "_blank"
        );
      }
    },
    //查看可视化
    toVisual({ project_number }) {
      this.$router.push({
        path: "/applicationVisual",
        query: { project_number },
      });
    },
    //列表
    _httpMyList(page, pagesize, search) {
      httpMyList(page, pagesize, search).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.total = data.data.total_records;
          this.tableData = data.data.data;
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  filters: {
    formatDate(time) {
      var data = new Date(time * 1000);
      return formatDate(data, "yyyy-MM-dd hh:mm:ss");
    },
  },
  mounted() {
    this._httpMyList(this.npage, this.pagesize);
  },
};
</script>

<style lang="scss" scoped>
.my_report {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    .search {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      .search_son {
        display: flex;
        margin-right: 10px;
        width: 200px;
        margin-bottom: 5px;
        .input,
        .select {
          display: inline-block;
          height: 28px;
          line-height: 28px;
          width: 100px;
        }
        &.time {
          width: 300px;
        }
        &.btn {
          width: 56px;
        }
        i {
          font-size: 24px;
          line-height: 30px;
          cursor: pointer;
        }
        &.refresh {
          line-height: 30px;
        }
      }
    }
    .search_btn {
      margin: 10px 0;
    }
    .look {
      color: #62b3ff;
      cursor: pointer;
      margin: 0 5px;
    }
    .page_footer {
      display: flex;
      justify-content: flex-end;
      margin: 20px;
    }
    /deep/ .el-table th {
      background-color: #f2f6fc !important;
    }
  }
}
</style>